/* global google */

const loadGoogleMapsApi = (apiKey) => {
    if (window.google && window.google.maps) {
        return Promise.resolve();
    }

    return new Promise((resolve) => {
        window.initGoogleMapsCallback = resolve;
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&loading=async&libraries=marker&callback=initGoogleMapsCallback`;
        script.async = true;
        document.head.appendChild(script);
    });
};

const createMarkerContent = (iconUrl, size) => {
    const img = document.createElement('img');
    img.src = iconUrl;
    img.alt = '';
    img.width = size;
    img.height = size;
    return img;
};

const map = (el) => {
    const data = window.map_data;
    if (!data || !data.apiKey || !data.center) {
        return;
    }

    const { apiKey, center, zoom, activeId, marker, markerActive, areas } = data;

    loadGoogleMapsApi(apiKey).then(() => {
        const googleMap = new google.maps.Map(el, {
            zoom: zoom,
            center: center,
            mapId: 'DEMO_MAP_ID',
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
        });

        new google.maps.TransitLayer().setMap(googleMap);
        new google.maps.BicyclingLayer().setMap(googleMap);

        const infoWindow = new google.maps.InfoWindow();

        Object.entries(areas).forEach(([id, area]) => {
            const isActive = Number(id) === Number(activeId);
            const iconSize = isActive ? 30 : 25;
            const areaMarker = new google.maps.marker.AdvancedMarkerElement({
                position: { lat: area.lat, lng: area.lng },
                map: googleMap,
                title: area.title,
                content: createMarkerContent(isActive ? markerActive : marker, iconSize),
            });

            areaMarker.addListener('gmp-click', () => {
                const image = area.image
                    ? `<img class="map__info-image" src="${area.image}" alt="${area.title}" />`
                    : '';
                infoWindow.setContent(
                    `<a class="map__info" href="${area.url}">
                        ${image}
                        <span class="map__info-title">${area.title}</span>
                        <span class="map__info-arrow" aria-hidden="true"></span>
                    </a>`
                );
                infoWindow.open(googleMap, areaMarker);
            });
        });
    });
};

export default map;
